angular.module('leanlaw').controller('ClientEditCtrl', ['$rootScope', '$scope', '$timeout', '$window', '$stateParams', 'leanLawApi', 'userService', '$state', 'clientManager', 'alerts', 'netDocsStatusService', function ($rootScope, $scope, $timeout, $window, $stateParams, leanLawApi, userService, $state, clientManager, alerts, netDocsStatusService) {
  // Scope variables
  $scope.saving = false;
  $scope.client = null;
  $scope.me = null;
  $scope.tempName = "";
  $scope.popup = $stateParams.popup;
  $scope.pattern = "";
  $scope.matterOnly = false;
  activate();

  // Scope functions
  $scope.startSave = startSave;
  $scope.cancel = done;
  $scope.search = search;
  $scope.selected = selected;
  $scope.nameChanged = recalculateDisplayName;
  $scope.customDisplayNameSet = customDisplayNameSet;
  $scope.cancel = cancel;

  ///////////////////////////////////

  const _clients = [];
  function activate() {
    userService.me().then(me => {
      $scope.me = me;
      if ((me.features?.timeEntriesTab ?? false) && (me.settings?.enableNewTimeEntry ?? false)) {
        $state.go('clients.client2', {
          methodOverride: 'client page'
        });
        return;
      }
      if (me.features.netdocs) {
        checkNetDocsStatus();
      }
      loadClient();
    });
    clientManager.list({
      scope: 'all'
    }).then(clients => {
      _clients.push.apply(_clients, clients);
    });
    if ($stateParams.clientId) {
      const deactivate = $rootScope.$on('$stateChangeStart', (event, transition) => {
        if ($scope.clientForm.$dirty) {
          alerts.warning("You have unsaved changes. Click save or cancel at the bottom of the form");
          event.preventDefault();
        } else {
          deactivate();
        }
      });
    }
  }
  function loadClient() {
    if ($stateParams.clientId) {
      clientManager.get($stateParams.clientId).then(client => {
        $scope.client = client;
        $scope.reference = $scope.client.reference;
        $scope.nextReference = $scope.reference;

        //Fill in tempName field for the display name
        if ($scope.client.contact.customName) {
          $scope.tempName = $scope.client.contact.customName;
        } else {
          //If no custom name (client is not using a custom name) use name field to set the disply name field.
          $scope.tempName = $scope.client.name;
        }
      });
    } else {
      $scope.client = {
        contact: {
          address: {}
        }
      };
      if ($scope.me.company.settings.billClient) {
        $scope.client.billing = {
          billClient: true
        };
      }
      $scope.loadingReference = true;
      leanLawApi.getMyCompanyReferences().then(result => {
        $scope.nextReference = result.nextClientReference;
        $scope.reference = $scope.nextReference;
        $scope.loadingReference = false;
      });
      $timeout(() => {
        const element = $window.document.getElementById('company');
        if (element) {
          element.focus();
        }
      });
    }
  }
  async function checkNetDocsStatus() {
    await netDocsStatusService.checkStatus();
    $scope.netDocsStatus = netDocsStatusService.state;
  }
  function startSave() {
    if (!$scope.tempName) {
      alerts.error("A company, contact person, or custom display name must be provided");
      return;
    }
    if ($scope.client.contact.email) {
      const emails = $scope.client.contact.email.split(',');
      const invalidEmails = emails.filter(email => !/^([a-zA-Z0-9_+\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(email.trim()));
      if (invalidEmails.length > 0) {
        alerts.error("Email is not valid. If providing multiple emails, separate with commas");
        return;
      }
    }
    if (!$scope.reference || $scope.reference === $scope.nextReference) {
      // There is no client reference or it is the default
      $scope.client.reference = $scope.client.id ? $scope.reference : null;
      finishSave();
      return;
    }
    const existing = _.find(_clients, c => c.reference === $scope.reference);
    if (existing && existing.id !== $scope.client.id) {
      clientAlreadyExists(existing);
    } else {
      $scope.client.reference = $scope.reference;
      finishSave();
    }
  }
  function finishSave() {
    $scope.saving = true;
    const updateOrCreate = $scope.client.id ? $scope.client.update() : clientManager.create($scope.client);
    updateOrCreate.then(client => {
      $scope.saving = false;
      $scope.clientForm.$setPristine(); //set form to pristine to 'reset' back to original, unaltered state

      done(client, !!$scope.client.id);
    }).catch(err => {
      $scope.saving = false;
      alerts.error(err);
    });
  }
  function cancel() {
    //For client tab
    loadClient();
    $scope.clientForm.$setPristine();
  }
  function selected(item) {
    if ($scope.client.id) {
      alerts.warning(`A client called '${item.name}' with that same id already exists`);
    } else {
      bootbox.confirm('A client with this id is already in the system. Use that client instead of creating a new one?', result => {
        if (!result) return;
        done(item);
      });
    }
  }
  function clientAlreadyExists(item) {
    bootbox.dialog({
      message: 'A client with this id is already in the system. Use that client or create a new one?',
      buttons: {
        cancel: {
          label: "Cancel",
          className: 'btn pull-left'
        },
        ok: {
          label: "Use Existing",
          className: 'btn-success',
          callback() {
            done(item);
          }
        },
        add: {
          label: "Create New",
          className: 'btn-success',
          callback() {
            $scope.client.reference = $scope.reference;
            finishSave();
          }
        }
      }
    });
  }
  function done(client, reload) {
    if (client && $scope.matter) {
      // matter and assignMatterToScope are expected in the parent scope
      $scope.matter.client = client;
      $scope.assignMatterToScope($scope.matter);
    }
    if ($scope.popup) {
      $state.go('^', {}, {
        reload
      });
    }
  }
  function search(name, prop = 'name') {
    name = name.toLowerCase();
    return _.filter(_clients, c => c[prop] && c[prop].toLowerCase().indexOf(name) >= 0);
  }

  //dynamically update displayName to be company or last,first depending on user settings.
  function recalculateDisplayName() {
    //If user has typed in a custom name, don't recalculate the display name based on other fields.
    if ($scope.client.contact.customName) {
      return;
    }
    let using_company = false;

    //Company
    if ($scope.client.contact.companyName) {
      //If company added or exists
      using_company = true;
      $scope.tempName = $scope.client.contact.companyName;
    } else {
      //If company deleted or doesn't exist
      $scope.tempName = '';
    }

    //First and last
    if (!using_company) {
      //company deleted or empty
      if ($scope.tempName) {
        //If display name already exists
        if ($scope.client.contact.last && $scope.client.contact.first) {
          $scope.tempName = [$scope.client.contact.first, $scope.client.contact.middle, $scope.client.contact.first, $scope.client.contact.suffix].join(" ");
        } else if ($scope.client.contact.last) {
          $scope.tempName = $scope.client.contact.last;
        } else if ($scope.client.contact.first) {
          $scope.tempName = $scope.client.contact.first;
        }
      } else if ($scope.client.contact.last && $scope.client.contact.first) {
        $scope.tempName = `${$scope.client.contact.last}, ${[$scope.client.contact.first, $scope.client.contact.middle, $scope.client.contact.suffix].join(" ")}`;
      } else if ($scope.client.contact.last) {
        $scope.tempName = $scope.client.contact.last;
      } else if ($scope.client.contact.first) {
        $scope.tempName = $scope.client.contact.first;
      }
    }
  }
  function customDisplayNameSet() {
    $scope.client.contact.customName = $scope.tempName;
  }
}]);